import Icon from "@/components/common/Icon"
import type {
  AdminDashboardStat,
  AdminStatTone,
} from "@/domain/admin/model/AdminDashboard"

/**
 * 지표 색은 아이콘 자리에만 쓴다 — 면을 채우지 않고 1px 테두리와 글자색으로 둔다
 * (배지와 같은 어법). 브랜드 레드 · 먹색 · 상태색 네 갈래 밖으로 색을 늘리지 않는다.
 */
const TONE_CLASSES: Record<AdminStatTone, string> = {
  brand: "text-app-primary-600",
  neutral: "text-app-text-400",
  attention: "text-app-amber-300",
  positive: "text-app-green-300",
}

interface AdminDashboardStatCardProps {
  stat: AdminDashboardStat
}

export default function AdminDashboardStatCard({
  stat,
}: Readonly<AdminDashboardStatCardProps>) {
  return (
    <article>
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="app-txt-body2 text-app-text-200">{stat.label}</p>
          <p className="app-txt-h1 mt-3">{stat.value}</p>
        </div>
        <span
          className={`flex size-11 shrink-0 items-center justify-center border border-current ${TONE_CLASSES[stat.tone]}`}
        >
          <Icon
            name={stat.icon}
            size={22}
          />
        </span>
      </div>
      <p className="app-txt-caption mt-4 font-medium text-app-text-200">
        {stat.detail}
      </p>
    </article>
  )
}
